import { FC } from 'react';
import { Box, Skeleton, Stack, Typography } from '@mui/material';

interface RequestDetailsCardProps {
  selfServeData: any;
  isLoading: boolean;
}

const RequestDetailsCard: FC<RequestDetailsCardProps> = ({ selfServeData, isLoading }) => {
  if (isLoading) {
    return (
      <Box
        sx={{
          width: '100%',
          backgroundColor: '#FFFFFF',
          padding: '1rem',
          borderRadius: '1rem',
          display: 'flex',
          flexDirection: 'column',
          gap: '1rem',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            gap: '0.75rem',
          }}
        >
          <Skeleton variant="rectangular" width={64} height={64} sx={{ borderRadius: '4px' }} />
          <Box
            sx={{
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              gap: '0.5rem',
            }}
          >
            <Skeleton variant="text" width={200} height={40} />
            <Skeleton variant="text" width={150} height={20} />
          </Box>
        </Box>

        <Box sx={{ display: 'flex' }}>
          <Box
            sx={{
              minWidth: '50%',
              display: 'flex',
              flexDirection: 'column',
              gap: '0.5rem',
              marginRight: '0.5rem',
            }}
          >
            <Skeleton variant="text" width={80} height={20} />
            <Skeleton variant="text" width={120} height={24} />
          </Box>
          <Box
            sx={{
              minWidth: '50%',
              display: 'flex',
              flexDirection: 'column',
              gap: '0.5rem',
              maxWidth: '8rem',
            }}
          >
            <Skeleton variant="text" width={80} height={20} />
            <Skeleton variant="text" width={120} height={24} />
          </Box>
        </Box>

        <Box sx={{ display: 'flex' }}>
          <Box
            sx={{
              minWidth: '50%',
              display: 'flex',
              flexDirection: 'column',
              gap: '0.5rem',
              marginRight: '0.5rem',
              maxWidth: '8rem',
            }}
          >
            <Skeleton variant="text" width={100} height={20} />
            <Skeleton variant="text" width={120} height={24} />
          </Box>
          <Box
            sx={{
              minWidth: '50%',
              display: 'flex',
              flexDirection: 'column',
              gap: '0.5rem',
              maxWidth: '8rem',
            }}
          >
            <Skeleton variant="text" width={100} height={20} />
            <Skeleton variant="text" width={120} height={24} />
          </Box>
        </Box>

        <Stack direction={'row'} gap={'0.5rem'} alignItems={'center'}>
          <Skeleton variant="text" width={120} height={24} />
        </Stack>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        width: '100%',
        backgroundColor: '#FFFFFF',
        padding: '1rem',
        borderRadius: '1rem',
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
      }}
    >
      <Box>
        <Typography
          sx={{
            fontWeight: 700,
            fontSize: '1rem',
            lineHeight: '1.325rem',
            marginBottom: '0.25rem',
          }}
        >
          {selfServeData?.name}
        </Typography>
        <Typography
          component="span"
          sx={{
            fontWeight: 600,
            fontSize: '0.75rem',
            color: '#6C6C6C',
            display: 'flex',
            alignItems: 'center',
            gap: '0.25rem',
          }}
        >
          {[selfServeData?.category, selfServeData?.genre].filter(Boolean).join(' • ')}
        </Typography>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginTop: '1rem',
          }}
        >
          <Box>
            <Typography
              sx={{
                fontSize: '0.75rem',
                lineHeight: '1rem',
                fontWeight: '600',
                color: '#6C6C6C',
                marginBottom: '0.25rem',
              }}
            >
              App ID
            </Typography>
            <Typography
              sx={{
                fontSize: '1rem',
                lineHeight: '1rem',
                fontWeight: '700',
                color: '#162936',
              }}
            >
              {selfServeData?.gameId}
            </Typography>
          </Box>
          <Box>
            <Typography
              sx={{
                fontSize: '0.75rem',
                lineHeight: '1rem',
                fontWeight: '600',
                color: '#6C6C6C',
                marginBottom: '0.25rem',
              }}
            >
              Email ID
            </Typography>
            <Typography
              sx={{
                fontSize: '1rem',
                lineHeight: '1rem',
                fontWeight: '700',
                color: '#162936',
              }}
            >
              {selfServeData?.email}
            </Typography>
          </Box>
        </Box>
        <Box sx={{ marginTop: '1rem' }}>
          <Typography
            sx={{
              fontSize: '0.75rem',
              lineHeight: '1rem',
              fontWeight: '600',
              color: '#6C6C6C',
              marginBottom: '0.25rem',
            }}
          >
            Company
          </Typography>
          <Typography
            sx={{
              fontSize: '1rem',
              lineHeight: '1rem',
              fontWeight: '700',
              color: '#162936',
            }}
          >
            {selfServeData?.companyName}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default RequestDetailsCard;
